import { render, staticRenderFns } from "./GroupPharmacies.vue?vue&type=template&id=a81a6f0a&"
import script from "./GroupPharmacies.vue?vue&type=script&lang=js&"
export * from "./GroupPharmacies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports